import type { Typographies } from "@superblocksteam/shared";

export const DEFAULT_DROPDOWN_WIDGET_INPUT_STYLE_VARIANT: keyof Typographies =
  "inputText";
export const DEFAULT_DROPDOWN_WIDGET_LABEL_STYLE_VARIANT: keyof Typographies =
  "inputLabel";

export const DEFAULT_DROPDOWN_BORDER = 1;
